<!--suppress HtmlFormInputWithoutLabel -->
<template>
  <div>
    <label :for="id">
      <slot></slot>
    </label>
    <textarea :id="id" cols="30" v-bind="$attrs" v-model="text"></textarea>
  </div>
</template>

<script>
export default {
  name: "InputArea",
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: String|null,
      required: true,
    },
  },
  data() {
    return {
      text: '',
    }
  },
  watch: {
    text(val) {
      this.$emit('update:value', val)
    },
    value(val) {
      this.text = val
    },
  },
  beforeMount() {
    this.text = this.value
  },
}
</script>

<style scoped lang="scss">

</style>
